import {NavLink} from 'react-router-dom';
import styles from './Sidebar.module.scss';
import {Nav} from "react-bootstrap";
import React, {useContext} from "react";
import DataContext from "../DataContext";

const Sidebar = () => {

    const {data} = useContext(DataContext);

    return (
        <div className={`d-none d-sm-block`}>
            <Nav className={`${styles.sidebar}`}  activeKey="/home">
                <p>Sezona</p>

                <ul className={styles.listSidebar}>
                    {
                        data && data.length>0 && data.map((item, idx)=>
                            <li key={idx}>
                                <NavLink activeClassName={styles.active} to={`/arhiva/${item.name}`}>
                                    {item.name}
                                </NavLink>
                            </li>)
                    }
                </ul>
            </Nav>
        </div>
    )
};

export default Sidebar;